import { classNames } from "primereact/utils";
import styles from "./LoginStep.module.scss";
import { AuthenticationForm } from "../../../../../common/components/authentication/AuthenticationForm/AuthenticationForm";
import { IUserModel } from "../../../../../common/infrastructure/hooks/useAuthentication";
import { routePaths } from "../../../../../common/infrastructure/routes/routePaths";
import { IAppointmentWizardState } from "../../models";
import { encodeAppointmentStateToUrl } from "../../utils/appointmentUrlStateUtility";

interface ILoginStepProps {
  onLoginSuccess: (user?: IUserModel) => void;
  className?: string;
  wizardState?: IAppointmentWizardState;
}

export const LoginStep = ({
  onLoginSuccess,
  className,
  wizardState,
}: ILoginStepProps) => {
  // Generate returnUrl with wizard state if provided

  // Store wizard state in localStorage with timestamp for expiry
  if (wizardState) {
    const backupWithTimestamp = {
      ...wizardState,
      timestamp: Date.now(),
    };
    localStorage.setItem(
      "wizardStateBackup",
      JSON.stringify(backupWithTimestamp)
    );
  }

  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.header}>
        <h2 className={styles.title}>Влезте в профила си</h2>
        <p className={styles.subtitle}>
          За да потвърдите резервацията, моля влезте в профила си
        </p>
      </div>

      <div className={styles.authForm}>
        <AuthenticationForm
          onLoginSuccess={(user) => {
            onLoginSuccess(user);
          }}
          showToasts={true}
          showGoogleLogin={true}
          showPolicyDialog={true}
          formClassName={styles.form}
          fieldsClassName={styles.fields}
          buttonClassName={styles.button}
          googleButtonClassName={styles.googleButton}
          compact={false}
        />
      </div>
    </div>
  );
};
